import { render, staticRenderFns } from "./TheSettings.vue?vue&type=template&id=2e469c72&"
import script from "./TheSettings.vue?vue&type=script&lang=ts&"
export * from "./TheSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports